export class ImpactCount {
  constructor(
    ecosystemBoomerangCount,
    ecosystemImpactMaterialCount,
    ecosystemImpactCo2Count,
    ademeOtherCount,
    ademeImpactMaterialCount,
    ademeImpactCo2Count,
    withoutEvaluationCount
  ) {
    this.ecosystemBoomerangCount = ecosystemBoomerangCount
    this.ecosystemImpactMaterialCount = ecosystemImpactMaterialCount
    this.ecosystemImpactCo2Count = ecosystemImpactCo2Count
    this.ademeOtherCount = ademeOtherCount
    this.ademeImpactMaterialCount = ademeImpactMaterialCount
    this.ademeImpactCo2Count = ademeImpactCo2Count
    this.withoutEvaluationCount = withoutEvaluationCount
  }
}
